import { useTranslation } from 'next-i18next';
import { BriefcaseIcon, HeartIcon, UserIcon } from '@heroicons/react/24/outline';
import { Heading, Tabs, TabItem } from '@restworld/ui-ds-base';

import { MainUserInformation } from './main-user-information';
import { WorkerExperiencesTab } from './worker-experiences-tab';
import { WorkerPreferencesTab } from './preferences-tab';

export const Header = () => {
  const { t: onboardingT } = useTranslation('onboarding-page');
  const { t: commonT } = useTranslation('common');
  const tabs: TabItem[] = [
    {
      label: onboardingT('on_you'),
      content: <MainUserInformation />,
      icon: <UserIcon className="w-5 h-5" />,
    },
    {
      label: commonT('experiences'),
      content: <WorkerExperiencesTab />,
      icon: <BriefcaseIcon className="w-5 h-5" />,
    },
    {
      label: commonT('preferences'),
      content: <WorkerPreferencesTab />,
      icon: <HeartIcon className="w-5 h-5" />,
    },
  ];
  return (
    <div className="flex flex-col w-full">
      <Heading size={3} className="mb-2">
        {onboardingT('make_cv_art_of_work')}!
      </Heading>
      <Heading size={5} color="muted-foreground" className="mb-[18px]">
        {onboardingT('keep_your_profile_updated')}
      </Heading>
      <Tabs sticky tabs={tabs} />
    </div>
  );
};
